import useTranslation from 'next-translate/useTranslation';
import { FunctionComponent } from 'react';
import Trans from 'next-translate/Trans';

const SEOContent: FunctionComponent<{
  withPart: boolean;
  selection: any;
  stock: string;
  info: any;
  vehicle: any;
}> = ({ withPart, selection, stock, info, vehicle }) => {
  const { t } = useTranslation();
  const subCategoryPlural = `parts-and-categories-plural:parts.${selection?.category.category}.${info?.subCategoryEnPart}`;

  return (
    <>
      <div className="lg:text-left text-[14px] leading-[24px] max-lg:text-base">
        <div className="container mx-auto px-4 pt-4 flex flex-col gap-2 text-justify">
          {withPart ? (
            <>
              <Trans
                i18nKey={'versions:seo-content.with-part'}
                components={{ p: <p /> }}
                values={{
                  brand: vehicle?.brand.name || '',
                  vehicle: `${vehicle?.brand.name || ''} ${
                    vehicle?.model?.name || ''
                  }`,
                  part: selection?.category.subCategory || '',
                  allWord:
                    info?.subCategoryType && info?.subCategoryType === 'F'
                      ? t('grammar:pronnouns.all.feminine')
                      : t('grammar:pronnouns.all.masculine'),
                  partPlural: info?.subCategoryEnPart
                    ? t(
                      subCategoryPlural,
                      {},
                      {
                        fallback: info?.subCategory,
                      }
                    )
                    : info?.subCategory,
                  oneWord:
                    info?.subCategoryType && info?.subCategoryType === 'F'
                      ? t('grammar:pronnouns.one.feminine')
                      : t('grammar:pronnouns.one.masculine'),
                  yoursWord:
                    info?.subCategoryType && info?.subCategoryType === 'F'
                      ? t('grammar:pronnouns.yours.feminine')
                      : t('grammar:pronnouns.yours.masculine'),
                  theSingularWord:
                    info?.subCategoryType && info?.subCategoryType === 'F'
                      ? t('grammar:pronnouns.theSingular.feminine')
                      : t('grammar:pronnouns.theSingular.masculine'),
                  theWord:
                    info?.subCategoryType && info?.subCategoryType === 'F'
                      ? t('grammar:pronnouns.the.feminine')
                      : t('grammar:pronnouns.the.masculine'),
                  usedWord:
                    info?.subCategoryType && info?.subCategoryType === 'F'
                      ? t('grammar:words.used.feminine')
                      : t('grammar:words.used.masculine'),
                }}
              />
            </>
          ) : (
            <>
              <Trans
                i18nKey={'versions:seo-content.no-part'}
                components={{ p: <p /> }}
                values={{
                  vehicle: `${vehicle?.brand.name || ''} ${
                    vehicle?.model?.name || ''
                  }`,
                  count: stock,
                  brand: vehicle?.brand.name || '',
                }}
              />
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default SEOContent;
